import {
  SET_CLINICS,
  SET_SELECTED_CLINIC,
  INITIALIZE_USER_APP_DATA,
  DELETE_CLINIC_ID,
  CLINIC_DETAILS,
  EDIT_CLINIC_ID,
  DELETE_GROUP_STATUS,
  PATIENTS_SHARED,
  STATEMENT_SELECTED_CLINIC,
  SET_LOGOUT_AUTH,
  SET_CLINIC_NOTIFICATION_BATCHES,
  BILLING_CLINIC_ID,
  GROUP_TYPE
} from '../actions/Index';

// Defining the initial state for the reducer
let initState = {
  list: [],
  selectedClinicInfo: {},
  selectedClinic: null,
  deleteClinicId: null,
  editClinicDetails: {},
  editClinicId: null,
  deleteGroupStatus: false,
  patientShared: '',
  emrProvider: '',
  groupType: '',
  selectedClinicId: [],
  selectedClinicLabel: [],
  zone: ''
};
let groupType = '';

export default function (state = initState, action: any): any {
  const {type, payload} = action;

  initState = state;

  switch (type) {
    case SET_CLINICS:
      return {
        ...state,
        list: payload.clinics || []
      };
    case SET_SELECTED_CLINIC:
      return {
        ...state,
        selectedClinic: payload.selectedClinic || null
      };
    case INITIALIZE_USER_APP_DATA:
      return {
        ...state,
        selectedClinic: payload.data.selectedClinic || null,
        list: payload.data.clinicList || []
      };
    case DELETE_CLINIC_ID:
      return {
        ...state,
        deleteClinicId: payload.deleteClinicId
      };
    case CLINIC_DETAILS:
      return {
        ...state,
        editClinicDetails: payload.editClinicDetails
      };
    case EDIT_CLINIC_ID:
      return {
        ...state,
        editClinicId: payload.editClinicId
      };
    case DELETE_GROUP_STATUS:
      return {
        ...state,
        deleteGroupStatus: payload.deleteGroupStatus
      };
    case PATIENTS_SHARED:
      return {
        ...state,
        patientShared: payload.patientShared,
        emrProvider: payload.emrProvider,
        splitStatement: !!payload.splitStatement,
        isMultiColumnMapping: !!payload.isMultiColumnMapping,
        consolidatedBillingGroupEnable: payload.consolidatedBillingGroupEnable,
        billingClinicId: payload.billingClinicId,
        showBillingPractice: payload.showBillingPractice
      };
    case BILLING_CLINIC_ID:
      return {
        ...state,
        billingClinicId: payload.billing_clinic_id
      };
    case STATEMENT_SELECTED_CLINIC:
      return {
        ...state,
        selectedClinicId: payload.selectedClinicId,
        selectedClinicLabel: payload.selectedClinicLabel,
        zone: payload.zone,
        emrProvider: payload.emrProvider
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState,
        selectedClinicId: [],
        selectedClinicLabel: [],
        zone: '',
        emrProvider: ''
      };
    case SET_CLINIC_NOTIFICATION_BATCHES:
      return {
        ...state,
        clinicNotificationBatches: payload.clinicNotificationBatches
      };
    case GROUP_TYPE: {
      groupType = payload.grouptype;
      return {
        ...state,
        groupType: payload.grouptype
      };
    }
    default:
      return state;
  }
}
export const _seletedGroupType = () => {
  return groupType;
};
